//データファイル(複数)取得API

import { convertDataFileListTaskIdList } from '@/features/siteTop/lib/convertDataFile';
import { DesignDataFilterState } from '@/features/siteTop/store/atom';
import { DataFile, DataFileEntity } from '@/features/siteTop/types';
import { axios } from '@/lib/axios';
import { OutputErrorLog } from '@/lib/error';

export type GetDataFilesQuery = Partial<DesignDataFilterState>;

export const getCalculatedAsBuiltDataFiles = async (siteId: number): Promise<DataFile[]> => {
  try {
    const result = await axios.get<DataFileEntity[]>(
      `/sites/${siteId}/data-file/asbuilt/calculated`
    );

    return convertDataFileListTaskIdList(result.data);
  } catch (error) {
    OutputErrorLog('getCalculatedAsBuiltDataFiles', error);
    return [];
  }
};
